import { ProtocolService } from './protocol.service';
import { ConfigService } from '@core/shared/config';
export function injectableProtocolFactory(token, name, loggers, extraFactory) {
  return {
    provide: token,
    useFactory: (ps, config) => {
      const protocol = ps.create({
        name
      });
      ps.assignLoggers(protocol, loggers);
      if (extraFactory) extraFactory(protocol, config);
      return protocol;
    },
    deps: [ProtocolService, ConfigService]
  };
}